import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1386.667,1226.667 L1280,1226.667 L1280,1440 C1280,1454.187 1285.653,1467.733 1295.573,1477.76 L1418.987,1601.066 L1494.4,1525.653 L1386.667,1417.92 L1386.667,1226.667 Z",
  transform: "translate(53)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1333.333,1813.333 C1127.467,1813.333 960,1645.867 960,1440 C960,1234.133 1127.467,1066.667 1333.333,1066.667 C1539.2,1066.667 1706.667,1234.133 1706.667,1440 C1706.667,1645.867 1539.2,1813.333 1333.333,1813.333 M1333.333,960 C1068.693,960 853.333,1175.36 853.333,1440 C853.333,1704.64 1068.693,1920 1333.333,1920 C1597.973,1920 1813.333,1704.64 1813.333,1440 C1813.333,1175.36 1597.973,960 1333.333,960",
  transform: "translate(53)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1493.333,426.667 L106.666,426.667 L106.666,266.667 C106.666,237.227 130.666,213.333 160,213.333 L320,213.333 L320,266.667 C320,296.107 343.894,320 373.333,320 C402.773,320 426.666,296.107 426.666,266.667 L426.666,213.333 L1173.333,213.333 L1173.333,266.667 C1173.333,296.107 1197.227,320 1226.667,320 C1256.107,320 1280,296.107 1280,266.667 L1280,213.333 L1440,213.333 C1469.333,213.333 1493.333,237.227 1493.333,266.667 L1493.333,426.667 Z M1440,106.667 L1280,106.667 L1280,53.333 C1280,23.893 1256.107,0 1226.667,0 C1197.227,0 1173.333,23.893 1173.333,53.333 L1173.333,106.667 L426.666,106.667 L426.666,53.333 C426.666,23.893 402.773,0 373.333,0 C343.894,0 320,23.893 320,53.333 L320,106.667 L160,106.667 C71.787,106.667 0,178.453 0,266.667 L0,1813.333 L746.666,1813.333 L746.666,1706.667 L106.666,1706.667 L106.666,533.333 L1493.333,533.333 L1493.333,853.333 L1600,853.333 L1600,266.667 C1600,178.453 1528.213,106.667 1440,106.667 L1440,106.667 Z",
  transform: "translate(53)"
}));

var IconCalendarClockLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCalendarClockLine, _Component);

  var _super = _createSuper(IconCalendarClockLine);

  function IconCalendarClockLine() {
    _classCallCheck(this, IconCalendarClockLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCalendarClockLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCalendarClock",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCalendarClockLine.displayName = "IconCalendarClockLine";
  return IconCalendarClockLine;
}(Component);

IconCalendarClockLine.glyphName = 'calendar-clock';
IconCalendarClockLine.variant = 'Line';
IconCalendarClockLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCalendarClockLine;
export { IconCalendarClockLine };